import UnitName from "../../Dealer/CurrentUnits/UnitName"
import { Flex } from "@chakra-ui/react"
import HighlightMatch from "../../../utilities/HighlightMatch"
import { colors } from "../../../utilities/colors"

export default function UnitRow({ unit, filter, isSelected, onClick, trailing }) {
  const clickable = typeof onClick === 'function'

  return (
    <Flex
      w="full"
      py={2}
      px={2}
      _hover={clickable ? { bg: colors.grey700, cursor: "pointer" } : undefined}
      _last={{ borderBottomWidth: 0 }}
      color={colors.grey300}
      textAlign="left"
      alignItems="center"
      borderBottom="2px solid"
      borderColor={isSelected ? colors.green : colors.grey700}
      bg={isSelected ? `${colors.green}10` : "transparent"}
      onClick={clickable ? () => onClick(unit) : undefined}
      transition="all 0.15s"
    >
      <Flex flexDir="column" flex={1} minW={0} overflow="hidden">
        <UnitName unit={unit} filter={filter} />
        {unit.attributes.vin && (
          <div className="text-xs">
            <HighlightMatch str={unit.attributes.vin} match={filter} truncate={true} />
          </div>
        )}
      </Flex>
      {trailing && (
        <Flex justifyContent="flex-end" alignItems="center">
          {trailing}
        </Flex>
      )}
    </Flex>
  )
}
